import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";

import "react-datetime/css/react-datetime.css";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import useAxiosFile from "../../actions/useaxios";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router";
import { LoadToast, updateToast } from "../../actions/common";
import { FaEye, FaPen, FaTrash } from "react-icons/fa";

function detaillist() {
  const navigate = useNavigate();
  const [dtlists, setDtlists] = useState([]);
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const axiosFile = useAxiosFile();

  useEffect(() => {
    showdata();
  }, []);

  const showdata = async () => {
    console.log("ddddd");
    var data = await axiosFile.showdata();
    console.log("vvvv", data);
    setDtlists(data?.data);
  };

  const submitbtn = async (cell) => {
    console.log("rtg", cell);
    navigate(`/templateview/?id=${cell._id}`);
  };

  const clickbtn = async (cell) => {
    const id = LoadToast();
    console.log("ccc", cell);
    const updatedata = {
      _id: cell._id,
      action: "statusupdate",
      status: true,
    };
    var data = await axiosFile.detailinsert(updatedata);
    console.log("ttttttttrue", data);
    updateToast(id, data.msg, data.success);
    if (data?.success == "success") {
      showdata();
    }
  };
  const columns = [
    {
      dataField: "type",
      text: "type",
      sort: true,
      formatter: (cell, row) => (
        <div dangerouslySetInnerHTML={{ __html: cell }}></div>
      ),
    },
    {
      dataField: "subject",
      text: "subject",
      sort: true,
      formatter: (cell, row) => <div>{cell}</div>,
    },
    // {
    //   dataField: "content",
    //   text: "content",
    //   sort: true,
    //   formatter: (cell, row) => (
    //     <div dangerouslySetInnerHTML={{ __html: cell }}></div>
    //   ),
    // },
    {
      dataField: "hideshow",
      text: "Edit",
      formatter: (cell, row) => (
        <div className="d-flex justify-content-center">
          <button
            class="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            type="button"
            onClick={() => submitbtn(row)}
          >
            <FaPen fontSize={14} />
            Edit
          </button>
        </div>
      ),
    },
    {
      dataField: "hideshow",
      text: "Delete",
      formatter: (cell, row) => (
        <div className="d-flex justify-content-center">
          <button
            class="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            type="button"
            onClick={() => clickbtn(row)}
          >
            <FaTrash fontSize={12} />
            Delete
          </button>
        </div>
      ),
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title">Email Template List</p>
            </div>
            {/* <div className="rightsec">
                          <button
                            type="button"
                            className="blue_btn add_deliveryprsn dp_btn_hover"
                            onClick={() => navigate("/templateview")}
                          >
                            Add
                          </button>
                        </div> */}
          </div>
        </div>
        <div className="row mt-4 mx-auto">
          <div className="sec_border">
            <div className="row">
              {
                dtlists?.length > 0 ?
                  <div className="ffd_table mar_bot">
                    <BootstrapTable
                      bootstrap4
                      keyField="id"
                      columns={columns}
                      data={dtlists}
                      pagination={pagination}
                      noDataIndication="No Email Template List found"
                    />
                  </div>
                  :
                  <div className="ffd_table mar_bot">
                    <p>No Email Template Found</p>
                  </div>
              }

            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default detaillist;
